import React, { useState, useEffect, useRef, useCallback } from 'react';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import { ROLES, s3Link } from '../../utils/constants';
import { Link, useHistory } from 'react-router-dom';
import moment from 'moment';
import { NOTIFICATION_TYPE } from '../../utils/constants';
import useDidMountEffect from '../../utils/useDidMountEffect';
import { useToasts } from 'react-toast-notifications';
import MetaTags from 'react-meta-tags';

import './my-notification.css';
import Avatar from '../../common/Avatar';
import { getNotificationIcon } from '../../utils/helper';
import { captureMessage } from '@sentry/react';
import { useMediaQuery } from '@mui/material';
import DefaultPUWidget from '../../Widgets/PU/Default';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { connect } from 'react-redux';
import DefaultWidget from '../../Widgets/SU/Default';
import CloseButton from '../../common/CloseButton';
import PageHeader from '../../common/PageHeader';
import styled from 'styled-components';

const PageHeaderWrapper = styled.div`
    padding-left: 10px;
    padding-right: 10px;
`;

const MyNotification = ({
    user
}) => {
    const history = useHistory();
    const isMobile = useMediaQuery('(max-width: 899px)');

    const { addToast } = useToasts();
    const [notifications, setNotifications] = useState([]);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(25);
    const userInformation = JSON.parse(localStorage.getItem('user'));
    const [isLoading, setIsLoading] = useState(false);
    const [filter, setFilter] = useState('all');
    const [hasMore, setHasMore] = useState(false);
    const [fetch, setFetch] = useState(false);
    const [totalNotif, setTotalNotif] = useState(0);

    useEffect(() => {
        setNotifications([]);
        setPage(1);
        setFetch(true);
    }, [filter]);

    useDidMountEffect(() => {
        if (fetch) {
            getNotifications('onload');
            getAllNotifications();
        }
    }, [fetch]);

    useEffect(() => {
        if (page > 1) {
            getNotifications('');
            getAllNotifications();
        }
    }, [page]);

    const getAllNotifications = () => {
        axios.get('/api/notifications/total')
            .then(response => {
                setTotalNotif(response.data.total);
            })
            .catch(error => {
                console.log({ error });
            })
            .finally(() => {
            });
    };

    const getNotifications = (source = 'onload') => {
        setIsLoading(true);
        axios.get(`/api/notifications`, {
            params: {
                per_page: perPage,
                page,
                filter
            }
        })
            .then(response => {
                setHasMore(response.data.data.length > 0);
                if (source == 'onload') {
                    setNotifications(response.data.data);
                } else {
                    const notificationIds = new Set(notifications.map(notification => notification.id));
                    const merged = source == 'onload'
                        ? [...response.data.data.filter(d => !notificationIds.has(d.id)), ...notifications]
                        : [...notifications, ...response.data.data.filter(d => !notificationIds.has(d.id))];

                    setNotifications(merged);
                }
                setFetch(false);
                // setNotifications(response.data.data)
                // setPage(response.data.page)
            })
            .catch(error => {
                console.log({ error });
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const observer = useRef();
    const lastNotificationElement = useCallback(node => {
        if (isLoading) return;
        if (observer.current) {
            observer.current.disconnect();
        }

        observer.current = new IntersectionObserver(entries => {
            console.log({ entries });
            if (entries[0].isIntersecting && hasMore) {
                setPage(page => page + 1);
            }
        });

        if (node) observer.current.observe(node);

        return () => {
            observer.current.disconnect();
        };
    }, [isLoading, hasMore]);

    const handleMarkAsRead = (e) => {
        if (e) {
            e.preventDefault();
        }

        axios.patch(`/api/notifications`, {
            all: true
        })
            .then(response => {
                // getNotifications('onload');
                // getAllNotifications();

                const notif = document.getElementById("totalNotif");
                if (notif)
                    notif.remove();
            })
            .catch(error => {
                addToast('Unable to mark notifications as read', { appearance: 'error', autoDismiss: true });
                captureMessage(error);
            });
    };

    useEffect(() => {
        setTimeout(() => {
            handleMarkAsRead();
        }, 2000);
    }, [notifications]);

    const Icon = ({ type }) => {
        const [icon, setIcon] = useState('');
        useEffect(() => {
            setIcon(getNotificationIcon(type));
        }, []);

        return Object.keys(icon).length > 0 && <span className="mr-1" style={{ color: '#0097fe' }}>
            <i className={`${icon.group} ${icon.icon}`} />
        </span>;
    };

    return (
        <div className="container pt-4">
            <MetaTags>
                <title>My Notification &#8211; Best way to make money as an influencer for your exclusive content</title>
                <meta name="description" content="Privaposts is a social media platform that lets influencers make money from their followers by keeping exclusive content hidden until a monthly subscription price has been paid." />
            </MetaTags>

            <Grid2
                container
                spacing={!isMobile ? 2 : 0}
            >
                <Grid2 md={8}>
                    <div className={`notification-contents-tab role-${userInformation.role}`}>
                        <PageHeaderWrapper>
                            <PageHeader title='Notifications' />
                        </PageHeaderWrapper>
                        <Tabs
                            defaultActiveKey="all"
                            transition={false}
                            onSelect={(k) => setFilter(k)}
                        >
                            <Tab eventKey="all" title={`All(${totalNotif})`} onSelect={(k) => setFilter('all')} />
                            {userInformation.role == ROLES.PU && <Tab eventKey={NOTIFICATION_TYPE.COMMENT} title="Comments" />}
                            <Tab eventKey={NOTIFICATION_TYPE.LIKES} title="Likes" />
                            {/* <Tab eventKey={NOTIFICATION_TYPE.NEW_SUBSCRIBER} title="New Subscribers" /> */}
                            {userInformation.role == ROLES.PU && <Tab eventKey={NOTIFICATION_TYPE.TIP_PPV} title="Tips+PPVs" />}
                            {userInformation.role == ROLES.PU && <Tab eventKey={NOTIFICATION_TYPE.PPV_REQUEST} title="PPV Requests" />}
                            <Tab eventKey={NOTIFICATION_TYPE.PRICE_CHANGE} title="Price changes" />
                            <Tab eventKey={NOTIFICATION_TYPE.ALERT} title="Alerts" />
                        </Tabs>

                        <div>
                            {/* <div className="notification-mark-read">
                                <Button type="button" variant="link" onClick={handleMarkAsRead}>
                                    Mark All As Read
                                </Button>
                            </div> */}
                            {notifications.map((notification, index) => {
                                if (notifications.length === index + 1) {
                                    return <div ref={lastNotificationElement}
                                        className={`notif-item-container${notification.status == 0 ? ' unread' : ''}`}
                                        key={notification.id}
                                    >
                                        <div className="notif-item-left">
                                            <div className="notif-item-image" style={{ width: '50px', height: '50px' }}>
                                                {notification.related && <Avatar pu={notification.related} story={false} size="50" />}
                                            </div>
                                            <div className="notif-item-name-days ml-2" style={{ marginTop: '-14px' }}>
                                                {notification.related && <p><Link to={`/${notification.related.login}`}>{notification.related.login}</Link></p>}
                                                <div className="notif-item-days">
                                                    <Icon type={notification.type} />
                                                    <span>
                                                        {
                                                            moment(moment.utc(notification.created_at).local().format()).fromNow()
                                                        }
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="notif-item-right">
                                            <p dangerouslySetInnerHTML={{ __html: notification.content }} />
                                        </div>
                                    </div>;
                                } else {
                                    return <div className={`notif-item-container${notification.status == 0 ? ' unread' : ''}`} key={notification.id}>
                                        <div className="notif-item-left">
                                            <div className="notif-item-image" style={{ width: '50px', height: '50px' }}>
                                                {notification.related && <Avatar pu={notification.related} story={false} size="50" />}
                                            </div>
                                            <div className="notif-item-name-days ml-2" style={{ marginTop: '-14px' }}>
                                                {notification.related && <p><Link to={`/${notification.related.login}`}>{notification.related.login}</Link></p>}
                                                <div className="notif-item-days">
                                                    <Icon type={notification.type} />
                                                    <span>
                                                        {
                                                            moment(moment.utc(notification.created_at).local().format()).fromNow()
                                                        }
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="notif-item-right">
                                            <p dangerouslySetInnerHTML={{ __html: notification.content }} />
                                        </div>
                                    </div>;
                                }
                            })}
                            {
                                notifications.length <= 0 ? <p className="p-4">No notifications for you!</p> : null
                            }
                        </div>
                    </div>
                </Grid2>

                {
                    !isMobile
                        ? <Grid2 className='pu-homepage__right' md={4}>
                            {
                                user && user.role == ROLES.PU ? <DefaultPUWidget /> : null
                            }
                            {
                                user && user.role == ROLES.SU ? <DefaultWidget /> : null
                            }
                        </Grid2>
                        : null
                }
            </Grid2>
        </div>
    );
};

const mapStateToProps = (state) => ({
    user: state.user.user,
});

export default connect(mapStateToProps)(MyNotification);
